<template>
    <div class="role-content">
        <el-card shadow="hover" class="left-bar">
            <div class="search">
                <el-input class="priv-select input-with-select" style="margin-right: 10px;" v-model="searchVal"
                    suffix-icon="el-icon-search" @keyup.enter.native="search">
                </el-input>
                <el-button class="btn btn1" icon="el-icon-circle-plus-outline" @click="addPriv">
                    {{ $t("message.button.create") }}</el-button>
                <el-button class="btn btn8" icon="el-icon-delete" @click="deleteTask">
                    {{ $t("message.button.delete") }}</el-button>
            </div>
            <div class="list-content" v-loading="loading">
                <el-table ref="singleTable" :data="taskList" style="width: 100%" height="calc(100vh - 240px )"
                    highlight-current-row @current-change="handleCurrentChange">
                    <el-table-column type="selection"></el-table-column>
                    <el-table-column prop="name" :label="$t('message.table.taskName')" :show-overflow-tooltip="true"
                        sortable width="120">
                    </el-table-column>
                    <el-table-column prop="description" :label="$t('message.table.taskDescription')"
                        :show-overflow-tooltip="true" sortable width="150">
                    </el-table-column>
                    <el-table-column prop="executeCycle" :label="$t('message.table.executeCycle')"
                        :show-overflow-tooltip="true" sortable width="150">
                    </el-table-column>
                    <el-table-column prop="className" :label="$t('message.table.taskStatus')"
                        :show-overflow-tooltip="true" sortable width="120">
                    </el-table-column>
                </el-table>
            </div>
        </el-card>
        <el-card shadow="hover" class="route-content">
            <router-view :privData="privData" :key="getKey" @setRefresh="refreshData"></router-view>
        </el-card>
        <el-dialog :close-on-click-modal="false" :title="$t('message.title.CreateNewScheduledTasks')"
            v-if="dialogVisible" :visible.sync="dialogVisible" width="50%" @close="closeEdit">
            <ScheduledTasks-Form :privData='privData' @submit="submitForm"></ScheduledTasks-Form>
        </el-dialog>
    </div>
</template>


<script>
import axios from "axios";
import ScheduledTasksForm from "./scheduledTasksInfo/scheduledTasksForm.vue";
export default {
    components: { ScheduledTasksForm },
    data() {
        return {
            searchVal: '',
            privData: {},
            options: [],
            value: '',
            allList: [],
            dialogVisible: false,
            loading: false,
            baseAllList: [],
        };
    },
    computed: {
        getKey() {
            const { path, query } = this.$route
            return path + query.id
        },
        taskList() {
            if (this.value === '') {
                return this.allList
            }
            const arr = this.allList.filter(i => {
                const id = this.value == 99 ? i.type : this.value;
                return id == i.type && i.name.toLowerCase().indexOf(this.searchVal.toLowerCase()) !== -1;
            })
            return arr
        },
    },
    watch: {},
    created() {
        this.getData();
    },
    methods: {
        async getData() {
            try {
                this.loading = true;
                const { data } = await axios.get("pmdm/clockTask/queryAllTasks");
                if (data.code === 200) {
                    this.allList = data.object.clockTasks.map(({
                        id,
                        name,
                        description,
                        typeName: executeCycle,
                        taskExecutionResult: className,
                        enabled
                    }) => ({
                        id,
                        name,
                        description,
                        executeCycle,
                        className,
                        enabled: enabled === 1
                    }));
                    this.baseAllList = this.allList;
                }
            } catch (error) {
                console.error('数据获取失败:', error);
            } finally {
                this.loading = false;
                this.getItem(this.allList[0]);
            }
        },
        handleCurrentChange(val) {
            this.getItem(val)
        },
        addPriv() {
            this.dialogVisible = true;
        },
        getActive(item) {
            const { query } = this.$route;
            if (item.id === query.id) {
                return 'activeList'
            }
            return ''
        },
        getItem(item) {
            const path = '/scheduledTask/scheduledTasksInfo';
            console.log(item);

            const query = item || this.allList[0];
            this.$refs.singleTable.setCurrentRow(query);
            this.$router.push({ path, query });
        },
        closeEdit() {
            this.privsForm = {};
        },
        async submitForm(e) {
            const obj = {
                name: e.task,
                description: e.taskDescription,
                type: e.executeCycle,
                executionTime: e.executeTime,
                weekDay: e.executionWeek,
                noticeType: e.notificationMethod,
                enabled: e.isEnabled,
                recipient: e.recipient,
                ccUser: e.cc
            };
            const { data } = await axios.post("pmdm/clockTask/saveClockTask", obj);
            if (data.code == 200) {
                this.$message.success(data.message);
                this.getData();
                this.dialogVisible = false;
            } else {
                this.$message.error(data.message);
            }
        },
        refreshData(obj) {
            if (!obj?.id) {
                return;
            }
            const typeMapping = {
                '1': '单次',
                '2': '每日',
                '3': '每周',
                '4': '每月'
            };
            const targetIndex = this.allList.findIndex(item => item.id === obj.id);
            if (targetIndex === -1) {
                console.warn(`No item found with id: ${obj.id}`);
                return;
            }
            const targetItem = this.allList[targetIndex];
            Object.assign(targetItem, {
                name: obj.name,
                description: obj.description,
                executeCycle: typeMapping[obj.type] || obj.type,
                enabled: ['1', '是'].includes(obj.enabled)
            });
            console.log(this.allList);

        },
        async deleteTask() {
            try {
                const selectedRows = this.$refs.singleTable.selection;
                const delIds = selectedRows.map(row => row.id);
                const { data } = await axios.post("pmdm/clockTask/deleteTaskByIds", { delIds });
                if (data.code === 200) {
                    this.$message.success(data.message || '操作成功');
                    this.getData();
                } else {
                    this.$message.error(data.message || '操作失败，请重试');
                }
            } catch (error) {
                console.error('删除失败:', error);
            }
        },
        async listSwitchChange(item) {
            try {
                const obj = {
                    id: item.id,
                    enable: item.enabled == true ? 1 : 0
                };
                const { data } = await axios.get(`/pmdm/clockTask/updateClockEnable${this.params(obj)}`);
                if (data.code === 200) {
                    this.$message.success(data.message || '操作成功');
                    this.getItem(item);
                } else {
                    this.$message.error(data.message || '操作失败，请重试');
                }
            } catch (error) {
                console.error('请求失败:', error);
            }
        },
        search() {
            const query = this.searchVal.trim().toLowerCase();
            if (!query) {
                this.allList = [...this.baseAllList]
                return
            }
            this.allList = this.baseAllList.filter(item => {
                return item.name && String(item.name).toLowerCase().includes(query.toLowerCase())
            });
        }
    }
};
</script>

<style>
.priv-select .el-select .el-input {
    width: 120px;
}

.priv-select.input-with-select .el-input-group__prepend {
    background-color: #fff;
}
</style>

<style scoped>
.role-content {
    display: flex;
    padding: 10px;
    gap: 10px;
}

.left-bar {
    flex-basis: 630px;
    flex-grow: 0;
    flex-shrink: 0;
}

.search {
    display: flex;
    margin: 8px 5px;
    margin-right: 0;
    gap: 8px;
}

.list-content {
    overflow-y: auto;
}

.route-content {
    flex: 1 1 auto;
    padding: 0 15px;
}

.role-item {
    font-size: 12px;
    margin: 3px;
    cursor: pointer;
    padding: 3px 5px;
    border-radius: 3px;
    display: flex;
    align-items: center;
}

.role-label {
    width: 260px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.role-item:hover {
    background-color: #f5f7fa;
}

.activeList {
    background: #409EFF;
    color: #fff;
}

.activeList:hover {
    background: #409EFF;
}

.del-item {
    margin-left: auto;
}

.activeList>.del-item {
    color: #f5f7fa;
}
</style>
